import React, { useState } from "react";
import { FaArrowRightToBracket } from "react-icons/fa6";
import AuthCard from "../../components/ui/Cards/AuthCard";
import logo from "../../assets/images/logo1.png";
import LogoBottom from "../../assets/images/shreepuram_vijay_prateek.png";
import logo1 from "../../assets/images/logo3.png";
import { toast } from "react-toastify";
import logo2 from "../../assets/images/Frame 47.png";
import logo3 from "../../assets/images/Frame 35.png";
import logo4 from "../../assets/images/logo7.png";
import logo5 from "../../assets/images/logo4.png";
import api from "../../api/axios";
import Input from "../../components/ui/Input/Input";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    // ✅ Validation
    if (!phoneNumber) {
      toast.error("Please enter your mobile number");
      return;
    }

    if (!/^\d{10}$/.test(phoneNumber)) {
      toast.error("Enter valid 10-digit mobile number");
      return;
    }

    setLoading(true);

    try {
      const response = await api.post(
        "/auth/check-phone",
        { phone: phoneNumber },
        { headers: { "Content-Type": "application/json" } }
      );

      const type = response?.data?.next;

      // ✅ Existing user → go to password page
      if (type === "login") {
        navigate("/password", {
          state: { phoneNumber },
        });
      } 
      // ✅ New user → go to signup
      else {
        toast.info("No account found. Please sign up to continue.");
        navigate("/signup", {
          state: { phoneNumber },
        });
      }

    } catch (error) {
      console.error("Check Phone Error:", error?.response?.data || error.message);
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard
      title={"Welcome"}
      title2={"to"}
      title3={"Bharat Jagriti ™"}
      description={"EXPLORE THE TRUTH TO THE WORLD"}
      navigateLink={"/signup"}
      pageTitle={"Login"}
      bottomImg={LogoBottom}
      bottomImgClass={"login-bottom-img"}
      topImgClass={"login-top-img"}
      bottomName={"Powered by Sripuram"}
      signUp={"Sign up"}
      msgInput={" Don't have an account?"}
      allImg={[logo3, logo2, logo4, logo5, logo1]}
      headLogo={logo}
      phoneNumber={phoneNumber}
      setPhoneNumber={setPhoneNumber}
      loading={loading}
    >
      <Input
        placeholder={"Enter your mobile number"}
        type={"tel"}
        length={10}
        value={phoneNumber}
        onKeyPress={(e) => e.key === "Enter" && handleLogin()}
        onchangeInput={(e) => {
          const value = e.target.value.replace(/\D/g, "");
          if (value.length <= 10) {
            setPhoneNumber(value);
          }
        }}
        Button={FaArrowRightToBracket}
        CountryCode={true}
        onClickBtn={handleLogin}
      />
    </AuthCard>
  );
};

export default Login;

// import React, { useEffect, useState } from "react";
// import { FaArrowRightToBracket } from "react-icons/fa6";
// import AuthCard from "../../components/ui/Cards/AuthCard";
// import logo from "../../assets/images/logo1.png";
// import LogoBottom from "../../assets/images/shreepuram_vijay_prateek.png";
// import logo1 from "../../assets/images/logo3.png";
// import {toast} from 'react-toastify'
// import logo2 from "../../assets/images/Frame 47.png";
// import logo3 from "../../assets/images/Frame 35.png";
// import logo4 from "../../assets/images/logo7.png";
// import logo5 from "../../assets/images/logo4.png";
// import api from "../../api/axios";
// import Input from "../../components/ui/Input/Input";
// import { useNavigate, Link } from "react-router-dom";

// const Login = () => {
//   const [phoneNumber, setPhoneNumber] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     if (!phoneNumber) {
//       toast.error("Please enter your mobile number")
//       return;
//     }

//     if (!/^\d{10}$/.test(phoneNumber)) {
//       toast.error("Enter valid 10-digit mobile number")
//       return;
//     }

//     const finalNumber = `${phoneNumber}`;
//     setLoading(true);

//     try {
//       const response = await api.post("/auth/check-phone",
//         { phone: finalNumber },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       const type = response.data.next;

//       if (type === "login") {
//         navigate("/password", {
//           state: { phoneNumber: finalNumber },
//           response,
//         });
//       } else {
//         toast.info("No account found. Please sign up to continue.")
//         navigate("/signup", {
//           state: { phoneNumber: finalNumber },
//         });
//       }
//     } catch (error) {
//       console.error("OTP Send Error:", error.response?.data || error.message);
//       toast.error("Something went wrong")
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <AuthCard
//       // title={"Welcome To Bharat Jagriti ™"}
//       title={"Welcome"}
//       title2={"to"}
//       title3={"Bharat Jagriti ™"}

//       description={"EXPLORE THE TRUTH TO THE WORLD"}
//       navigateLink={"/signup"}
//       pageTitle={"Login"}
//       bottomImg={LogoBottom}
//       bottomImgClass={'login-bottom-img'}
//       topImgClass={'login-top-img'}
//       bottomName={"Powered by Sripuram"}
//       signUp={'Sign up'}
//       msgInput={" Don't have an account?"}
//       allImg={[logo3, logo2, logo4, logo5, logo1]}
//       headLogo={logo}
//       phoneNumber={phoneNumber}
//       setPhoneNumber={setPhoneNumber}
//       loading={loading}>
//       <Input
//         placeholder={"Enter your mobile number"}
//         type={"tel"}
//         length={10}
//         value={phoneNumber}
//         onKeyPress={(e) => e.key === "Enter" && handleLogin()}
//         onchangeInput={(e) =>{
//           const value = e.target.value.replace(/\D/g, "");
//            if (value.length <= 10) {
//               setPhoneNumber(value);
//             }
//         }}
//         Button={FaArrowRightToBracket}
//         CountryCode={true}
//         onClickBtn={handleLogin}
//       />
//     </AuthCard>
//   );
// };

// export default Login;
